import { useToastProvider } from '@qualio/ui-components';
import { useTranslation } from 'react-i18next';
import { useQuery } from 'react-query';

import { changeControlApi } from '../api/changeControl';
import { ChangeControlWithTemplate } from '../types/DocumentCreate';

export const useChangeControlWithTemplate = (
  companyId: number,
  changeControlId: string | undefined,
): {
  changeControlWithTemplate: ChangeControlWithTemplate | undefined;
  isLoading: boolean;
} => {
  const { t } = useTranslation();
  const { showToast } = useToastProvider();

  const { data: changeControlWithTemplate, isLoading } =
    useQuery<ChangeControlWithTemplate>({
      queryKey: ['changeControlWithTemplate', changeControlId],
      queryFn: () =>
        changeControlApi.fetchChangeControlWithTemplate(
          companyId,
          changeControlId as string,
        ),
      enabled: !!changeControlId,
      refetchOnWindowFocus: false,
      onError: () => {
        showToast({
          id: 'fetch-cc-with-template-error',
          'data-cy': 'fetch-cc-with-template-error-toast',
          status: 'error',
          title: t('notifications.error'),
          description: t('documentActions.failedToGetDocumentCreationInfo'),
          replace: true,
        });
      },
    });

  return { changeControlWithTemplate, isLoading };
};
